module.exports = __webpack_public_path__ + "img/Juandalynn Givan.581992bf.jpg";